import { Container, Graphics, type ContainerOptions, type DestroyOptions } from 'pixi.js';

const owners = new WeakMap<Graphics, TileArtwork>();

/** Pixi 8 leaf graphics and their text/sprites share a transform on a Container. */
export class TileArtwork extends Container {
  readonly graphics: Graphics;

  constructor(_options: ContainerOptions = {}, graphics = new Graphics()) {
    super();
    this.graphics = graphics;
    owners.set(graphics, this);
    this.addChild(graphics);
  }

  set redraw(draw: (graphics: Graphics) => void) {
    draw(this.graphics);
  }

  destroy(options?: DestroyOptions) {
    super.destroy(
      typeof options === 'object' ? { ...options, children: true } : { children: true },
    );
  }
}

export function tileArtwork(graphics: Graphics): TileArtwork {
  return owners.get(graphics) ?? new TileArtwork({}, graphics);
}

export function tileArtworkChildren(graphics: Graphics): Container[] {
  return owners.get(graphics)?.children.filter((child) => child !== graphics) ?? [];
}

export function clearTileArtwork(graphics: Graphics) {
  for (const child of tileArtworkChildren(graphics)) child.destroy({ children: true });
}

export function addTileArtwork(graphics: Graphics, child: Container) {
  return tileArtwork(graphics).addChild(child);
}
